import { combineReducers } from 'redux'

import { IBonusHistoryState } from '../types'
import communications from './communications'
import data from './data'

export const reducer = combineReducers<IBonusHistoryState>({
  communications,
  data,
})
